import { httpClient } from '@/services/http/httpClient'

export async function resetUserScores() {
  await httpClient.put('/tennants/configs/points/reset')
}
